import axios from 'axios'
import type {
  FetchFoldersParams,
  FolderItem,
  FolderWriteItem,
  FolderWritePayload,
  FoldersResponse,
} from '../types/folder.types'
import { normalizeFolderTree } from '../utils/folderTree'
import { extractCursor } from '../utils/cursorHelpers'
import { BASE_URL } from '@/environment/environment'

const API_BASE = `${BASE_URL}/api/documents`

function toFolderApiId(id: FolderItem['id']): FolderItem['id'] {
  if (id == null || id === '') {
    throw new TypeError('Некорректный идентификатор папки')
  }

  return id
}

export class FoldersApi {
  static async fetchFolders(params?: FetchFoldersParams): Promise<FoldersResponse> {
    const pageSize = params?.page_size ?? 500
    let cursor = params?.cursor
    const results: FolderItem[] = []
    let totalDocuments: number | undefined
    let count = 0
    let guard = 0

    do {
      const { data } = await axios.get<FoldersResponse>(`${API_BASE}/folder/`, {
        params: {
          ...params,
          page_size: pageSize,
          ...(cursor ? { cursor } : {}),
        },
      })

      results.push(...normalizeFolderTree(data.results ?? []))
      count = data.count ?? results.length
      if (data.total_documents != null) {
        totalDocuments = data.total_documents
      }
      cursor = extractCursor(data.next)
      guard += 1
    } while (cursor && guard < 20)

    return {
      count,
      next: null,
      previous: null,
      results,
      total_documents: totalDocuments,
    }
  }

  static async createFolder(payload: FolderWritePayload): Promise<FolderWriteItem> {
    const { data } = await axios.post<FolderWriteItem>(`${API_BASE}/folder/`, payload)

    return data
  }

  static async updateFolder(
    folderId: FolderItem['id'],
    payload: FolderWritePayload,
  ): Promise<FolderWriteItem> {
    const { data } = await axios.patch<FolderWriteItem>(
      `${API_BASE}/folder/${toFolderApiId(folderId)}/`,
      payload,
    )

    return data
  }

  static async deleteFolder(folderId: FolderItem['id']): Promise<void> {
    await axios.delete(`${API_BASE}/folder/${toFolderApiId(folderId)}/`)
  }
}
